import { Spin } from "antd";
import { showError } from "common/ToastNotifications";
import ViewsQuadrant from "components/organisms/ViewsQuadrant";
import AppPaths from "constants/appPaths";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

class ViewsHomeOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    componentDidMount() {
        this.props.getRecentViews();
        this.props.getUserViewResourcePermission();
        if (!this.props.recentViewsResult || !this.props.recentViewsResult.Items || this.props.recentViewsResult.Items.length === 0) {
            this.setState({ loading: true });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.getRecentViewsResult !== this.props.getRecentViewsResult) {
            this.setState({ loading: false });
            if (this.props.getRecentViewsResult && !this.props.getRecentViewsResult.success) {
                showError("Failed to load recent views");
            }
        }
    }

    onViewDetail = (viewId) => {
        const tenant = this.props.tenant;
        if (tenant) {
            this.props.history.push(
                AppPaths.TENANT_VIEW_DETAIL.replace(":tenant", tenant.name).replace(":viewId", viewId)
            );
        }
    };

    onRunView = (viewId) => {
        this.props.runView(viewId);
    };

    render() {
        return (
            <Spin spinning={this.state.loading} size="small">
                <ViewsQuadrant
                    views={this.props.recentViewsResult?.Items || []}
                    selectedViewId={this.props.selectedViewId}
                    onSelectView={this.props.onViewSelected}
                    onViewDetail={this.onViewDetail}
                    onRunView={this.onRunView}
                    permission={this.props.resourcePermission}
                />
            </Spin>
        );
    }
}

const mapStateToProps = (state) => ({
    tenant: state.userLogin.tenant,
    recentViewsResult: state.views.recentViewsResult,
    getRecentViewsResult: state.views.getRecentViewsResult,
    resourcePermission: state.views.resourcePermission,
});

const mapDispatchToProps = (dispatch) => ({
    getRecentViews: () => dispatch(actions.getRecentViewsRequest()),
    runView: (viewId) => dispatch(actions.runViewRequest(viewId)),
    getUserViewResourcePermission: () => dispatch(actions.getUserViewResourcePermissionRequest()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewsHomeOverview));
